import script from "./Add-New-Client-Main.vue?vue&type=script&setup=true&lang=js"
export * from "./Add-New-Client-Main.vue?vue&type=script&setup=true&lang=js"

import "./Add-New-Client-Main.vue?vue&type=style&index=0&id=1b70def6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b70def6"]])

export default __exports__